module.exports = __webpack_public_path__ + "static/img/video_icon1_2.1c0dc1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon1_2.png
// module id = ILOw
// module chunks = 0